import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import IconExclamation from "@mui/icons-material/WarningAmberRounded";
import { StatusChip, type StatusChipStatus } from "components/CriticalIncident/components/Shared/StatusChip";
import { IncidentReportStatus } from "components/CriticalIncident/interfaces";

interface IncidentReportStatusChipPorps {
  status: IncidentReportStatus
  href?: string
  hasError?: boolean
}

export const IncidentReportStatusChip: FunctionComponent<IncidentReportStatusChipPorps> = ({ status, href, hasError }) => {
  const { t, ready: translationsReady } = useTranslation('criticalIncident');

  const ReportStatuses: Record<string, { status: StatusChipStatus; label: string }> = {
    [IncidentReportStatus.Open]: { status: 'default', label: t('not_started') },
    [IncidentReportStatus.InProgress]: { status: hasError ? 'error' : 'warning', label: t('in_progress') },
    [IncidentReportStatus.Submitted]: { status: 'success', label: t('submitted') },
    undefined: { status: 'default', label: t('not_started') },
  };

  const { status: statusText, label } = ReportStatuses[status] || {};

  return translationsReady && (
    <StatusChip status={statusText} label={label} href={href} icon={hasError ? <IconExclamation color="error" style={{ fontSize: '1.25rem' }} /> : undefined} />
  );
}
